import { render } from "./BatteryHistory.vue?vue&type=template&id=d45b1952"
import script from "./BatteryHistory.vue?vue&type=script&lang=js"
export * from "./BatteryHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerOrbit from 'quasar/src/components/spinner/QSpinnerOrbit.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QSpinnerOrbit});qInstall(script, 'directives', {ClosePopup});
